/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r={current:!1};export{r as instantAnimationState};
//# sourceMappingURL=use-instant-transition-state.js.map
